import React from 'react';

export default class Page6 extends React.Component {

    _savePageStatus = (nextPage) => () => {

        this.props.handleChangeMainPage(nextPage)();

        if (this.props.incompletePage)
            this.props.savePageStatus()('HowToManageYourImpact');
    }

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">


                                            <div className="border_subtitle">Talk to your role model</div>
                                            <p>Consider someone you know who has a positive impact on those
                                                around them. Think about what it is particularly that you think
                                                is great about them or their approach. You may then want to
                                                think about how you compare. This may seem daunting if you feel
                                                that there is a big gap but this is the starting point for you
                                                to develop a plan to improve. Think about what your role model
                                                would do to have a positive impact and whether you would also
                                                use this approach. Think about any successful approaches they
                                                use that you are not currently using. You could also discuss
                                                your impact management matrix with them.</p>
                                            <div className="border_subtitle">Write a development plan</div>
                                            <p>Use the tool in this document to highlight your approach to
                                                managing your impact. Once you have established how you go about
                                                creating a positive impact you could put together a focused
                                                development plan to improve your effectiveness. Ensure that you
                                                put in time to review this in the future, in order to measure
                                                your progress.</p>
                                            <div className="border_subtitle">Gather feedback on existing
                                                performance
                                            </div>
                                            <p>You may find it useful to benchmark your current performance by
                                                asking for formal or informal feedback. This can help you
                                                understand how you can help others around you and where people
                                                would like you to be more visible.</p>
                                            <div className="border_subtitle">Look for opportunities to
                                                practise
                                            </div>
                                            <p>Think about the opportunities that you have in your current work,
                                                or beyond, where you can practise managing your impact and
                                                making a positive impression.</p>

                                            <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span className="heading">Further Information</span>
                                            </div>
                                            <div className="paraspace"><p
                                                style={{paddingBottom:'0px !important'}}>If you found this tool
                                                useful then you are likely to find the following tools both
                                                insightful and relevant:</p></div>
                                            <div className="keyquestionpad">
                                                <ul className="greenbullet-list sept">
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToDevelopRapport')}>How
                                                        to develop rapport</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToRaiseEnergyLevels')}>How
                                                        to raise energy levels</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToBeAssertive')}>How
                                                        to be assertive</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToBuildAndMaintainTrust')}>How
                                                        to build and maintain trust</div></li>


                                                </ul>
                                            </div>
                                            <div className="circle_title "><img
                                                src={require('@images/browndot.jpg')}
                                                alt=""/>REFERENCES</div>

                                            <ol className="testclass">
                                                <li><p className="further_info_content">Moscovici, S. Lage,
                                                    E. &amp; Naffrenchoux, M. (1969). Influences of a consistent
                                                    minority on the responses of
                                                    a majority in a colour perception task,<span
                                                        className="subtiltereg"> Sociometry,</span> 32, 365-80.
                                                </p></li>


                                            </ol>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page8')}
                                                    className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this._savePageStatus('People')}
                                                    className="button-next-previous-done">Done
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    ;
    }
    }